import type { ReactElement } from 'react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import Spacer from '@ui-kit/components/layoutComponents/Spacer/index.web'

import * as styles from './styles'
import type { WebProps } from './types'
import { withSpacers } from './withSpacers'

const Stack = (props: WebProps): ReactElement => {
  const { space, ...divProps } = props
  const stackItems = withSpacers(props.children, (key) => (
    <Spacer size={space || styles.DEFAULT_SPACE} key={key} />
  ))

  return (
    <div
      {...divProps}
      className={twMerge('flex flex-col', divProps.className)}
      data-testid={props.id}
    >
      {stackItems}
    </div>
  )
}

export default Stack
